// UI plugin

import Vue from 'vue'
import VueScreen from 'vue-screen'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(VueScreen, 'bootstrap')
